import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class WizardStepsService {
  private _numberOfSteps: number = 0;
  private _onMoveTo = new EventEmitter<number>();
  _onMoveSteps = new Set();
  get numberOfSteps() { return this._numberOfSteps }
  //get activeStep() { return 6 };

  _isLastStep = false;
  get isLastStep() { return this._isLastStep; }

  activeStep = new BehaviorSubject<number>(1);



  constructor() {
    this.activeStep.asObservable().subscribe(val => {
      this._isLastStep = val == this._numberOfSteps
    })
  }


  init(nOfSteps: number) {
    this._numberOfSteps = nOfSteps;
    this.setStartingStep(1);
  }
  moveToNextStep() {
    this.activeStep.next(this.activeStep.value + 1);
    this.emitOnMove();
  }

  moveToPreviousStep() {
    this.activeStep.next(this.activeStep.value - 1);

    this.emitOnMove();
  }

  setStartingStep(step: number) {
    this.activeStep.next(step);
    this.emitOnMove();
  }

  /** moving the registration process to the provided step number */
  moveToStep(stepNumber: number) {
    this.activeStep.next(stepNumber);
    this.emitOnMove();
  }

  /**
   * 
   * @param stepNumber Pass null to listen to any step number changed
   * @returns 
   */
  subscribeOnMove(stepNumber: number | null) {
    this._onMoveSteps.add(stepNumber);
    return this._onMoveTo;
  }

  private emitOnMove() {
    if (this._onMoveSteps.has(null) || this._onMoveSteps.has(this.activeStep.value)) {
      this._onMoveTo.emit(this.activeStep.value);
    }
  }

}
